import { BookingPresenter } from '@shared/modules/bookings/booking.presenter';
import {
    CarerBookingAllocationPresenter
} from '@shared/modules/carer-booking-allocations/carer-booking-allocation.presenter';
import { CarerContractPresenter } from '@shared/modules/carer-contracts/carer-contract.presenter';
import {
    ClientCarerCompatibilityPresenter
} from '@shared/modules/client-carer-compatibility/client-carer-compatibility.presenter';
import { TeamPresenter } from '@shared/modules/teams/team-presenter';
import { UserPresenter } from '@shared/modules/users/user.presenter';
import type { CarerContract } from '../carer-contracts/carer-contract';
import type { EmployeeJobTitle } from '../employee-job-title/employee-job-title';
import { mapMarkerForPerson } from '../maps';
import { BelongsToPersonPresenter } from '../people/person.presenter';
import type { Carer } from './carer';

export class CarerPresenter extends BelongsToPersonPresenter<Carer> {
    get allocation(): CarerBookingAllocationPresenter {
        return this.present('allocation.data', CarerBookingAllocationPresenter);
    }

    get defaultTeam(): TeamPresenter {
        return this.present('default_team.data', TeamPresenter);
    }

    get teams(): TeamPresenter[] {
        return this.present('teams.data', TeamPresenter);
    }

    get teamNames(): string[] {
        return this._get('teamNames', () => this.teams.map(team => team.name));
    }

    get bookings(): BookingPresenter[] {
        return this.present('bookings.data', BookingPresenter);
    }

    get nextCarer(): CarerPresenter {
        return this.present('next_carer.data', CarerPresenter);
    }

    get previousCarer(): CarerPresenter {
        return this.present('previous_carer.data', CarerPresenter);
    }

    get activeContracts(): CarerContractPresenter[] {
        return this.present('active_contracts.data', CarerContractPresenter);
    }

    get mapMarkerIcon(): any {
        return this._get('mapMarkerIcon', () => mapMarkerForPerson('carer', this.data?.person?.data?.gender));
    }

    get defaultContract(): CarerContract {
        return this._get('defaultContract', () => this.activeContracts.find(contract => contract.data.is_default));
    }

    get compatibility(): ClientCarerCompatibilityPresenter {
        return this.present('compatibility.data', ClientCarerCompatibilityPresenter);
    }

    get employeeJobTitle(): EmployeeJobTitle {
        return this._get('employeeJobTitle', () => this.data.employee_job_title?.data);
    }

    get createdBy(): UserPresenter {
        return this.present('created_by.data', UserPresenter);
    }
}
